// VND formatting. List views round to whole đồng; detail may keep fractions
// when the backend actually returns them.

const isEmpty = (n) => n == null || n === "" || Number.isNaN(Number(n))

export const roundVnd = (n) => {
  if (isEmpty(n)) return null
  return Math.round(Number(n))
}

export const formatVndExact = (n) => {
  if (isEmpty(n)) return "—"
  return `${Number(n).toLocaleString("vi-VN")} ₫`
}

export const formatVnd = (n, { precise = false } = {}) => {
  if (isEmpty(n)) return "—"
  const value = precise ? Number(n) : Math.round(Number(n))
  return `${value.toLocaleString("vi-VN")} ₫`
}

// Compact label for large figures (KPI tiles). Always pair with a `title`
// of the full amount — never show this without the exact value on hover.
export const formatVndCompact = (n) => {
  if (isEmpty(n)) return "—"
  const value = Math.round(Number(n))
  const abs = Math.abs(value)
  const sign = value < 0 ? "-" : ""
  if (abs >= 1_000_000_000) {
    const ty = abs / 1_000_000_000
    const s = ty.toLocaleString("vi-VN", { maximumFractionDigits: 1, minimumFractionDigits: 0 })
    return `${sign}${s} tỷ`
  }
  if (abs >= 1_000_000) {
    const tr = abs / 1_000_000
    const s = tr.toLocaleString("vi-VN", { maximumFractionDigits: 1, minimumFractionDigits: 0 })
    return `${sign}${s} tr`
  }
  return formatVnd(value)
}
